export default {
  methods: {
    trackClearFilterEvent() {
      this.$analytics.trackEvent('click', {
        params: {
          event_category: 'Filters',
          event_action: 'Clear',
          event_label: 'CLEAR ALL FILTERS'
        }
      })
    },
    trackFilterEvent(event, args = {}) {
      this.$analytics.trackEvent('click', {
        params: {
          event_category: 'Filters',
          event_action: `Click ${args.type} Filter`,
          event_label: args.value,
          cm8: event.includes(args.slugUrl) ? 1 : -1,
          cd48: args.filterIndex,
          cd49: args.filterCategoryIndex
        }
      })
    }
  }
}
